import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'transaction-list',
  templateUrl: './transaction-list.component.html',
	styleUrls:['./transaction-list.component.scss']
})
export class TransactionListComponent {
    
  @Input() showNoResults = false;
  @Input() hand: any[];
  @Input() totalRecords: number = 0;
  @Input() currentHandDetails: any;
  @Input() currentPage: number = 1;
  @Input() currentPageDetails: number = 1;
  @Input() maxPage: number = 1;
  @Input() maxPageDetails: number = 1;
  
  @Output() onViewDetails = new EventEmitter<any>();
  @Output() onPageScroll = new EventEmitter<number>();

  constructor() {}

  onPageChangeDetails(event) {
      this.currentPageDetails = event;

      this.onPageScroll.emit(this.currentPageDetails);
  }
}
